<template>
    <div :class="className">
         <div ref="wrapper" :class="contentStyle">
            <div v-for="(item, i) in items" class="c-card-viewer__item"
                :key="`selectionCard-${i}`">
                <aha-selection-card
                    v-bind="{...cardOptions, ...item}"
                ></aha-selection-card>
                <div v-if="isList" class="c-selection-card-details">
                    <div class="h3">{{ item.mediaTitle }}</div>
                    <p>{{ item.mediaText }}</p>
                    
                    <div class="card-media-container">
                       
                        <div class="card-media" :class="item.downloadLink  ? 'card-media--border' : ''" v-if="item.mediaLink">
                            <a :href="item.mediaLink" :class="item.mediaLinkClass" :target="item.mediaLinkTarget" tabindex="0" class="btn--vol-media-play"><span class="sr-only">Play <span v-html="item.mediaLinkDescription"></span></span></a>
                            <div>
                                <div v-if="item.mediaLinkDescription" class="info small" v-html="item.mediaLinkDescription"></div>
                            </div>
                        </div>

                        <div class="card-action" v-if="item.downloadLink">
                            <a :href="item.downloadLink" class="btn btn-round btn-outline-primary" :class="item.downloadLinkClass" :target="item.downloadLinkTarget">{{item.downloadButtonText}}</a>
                        </div>

                    </div>

                </div>
            </div>
            <div v-if="!items">
                <slot v-bind:items="items" v-bind:count="count" />
            </div>
        </div>
    </div>
</template>

<script>
import Vue from "vue";
import { each, size, slice, shuffle, reduce } from "lodash";
import { initStore } from "../store/modules/card-selector";
import { mapState, mapGetters } from 'vuex'
export default {
    data() {
        return {
            filters: [],
            maxHeight: 0
        };
    },
    props: {
        data: [],
        mode: {
            type: String,
            default: 'stack',
            validator (value) {
                return (typeof value === 'string' &&
                (value === 'stack' || value === 'stacked' || value === 'list' ))
            }
        },
    },
    beforeCreate() {
        this.$store = initStore();
        this.$store.commit('initialiseStore');
    },
    mounted() {
      this.resize();  
    },
    methods: {
        resize() {
            const container = this.$refs['wrapper'];
            const items = container.getElementsByClassName('c-selection-card');
            const itemContainers = container.getElementsByClassName('c-card-viewer__item');
            let height = 0;
            let width = 0;
            let padding;
            each(items, card => {


                //height = (height < card.offsetHeight) ? card.offsetHeight : height;
                width = (width < card.offsetWidth) ? card.offsetWidth : width;

                if (height < card.offsetHeight) {
                    height = card.offsetHeight;

                    console.log('inside viewer');
                    console.log('height', height);
                    console.log('card.offsetHeight', card.offsetHeight)
                }

                if(height > 350){
                    height = 350;
                }

            });
            
            if(this.isList) {
                const totalHeight = reduce(itemContainers, (th, item) => {
                    return th + item.offsetHeight;
                }, 0);
                container.style.height = `${totalHeight}px`;
            } else {
                container.style.height = `${height}px`;
                container.style.width = `${width}px`; 
            }

            each(items, card => {
                card.style.height = `${height}px`;
            });
        },
    },
    computed: {
        ...mapGetters({
            selectedItems: 'selectedItems',
        }),
        cardOptions: function (index) {
            return {
                boxShadow: true
            };
        },
        contentStyle: function () {
            return {
                'c-card-viewer__content': true,
                [`stack-of-${size(this.items)}`]: this.mode === 'stack'
            };
        },
        className: function () {
            return {
                'c-card-viewer': true,
                'c-card-viewer__stack': this.mode === 'stack',
                'c-card-viewer__list': this.mode === 'list'
            }
        },
        items: function() {
            let mode = this.mode.toLowerCase();
            if(mode !== 'list') {
                let items = [];
                let len = size(this.selectedItems) < 3 ? size(this.selectedItems) : 3;
                return slice(shuffle(this.selectedItems), 0, len);
            }
            return this.selectedItems;
        },
        count: function() {
            return this.items.length;
        },
        isList: function() {
            return this.mode === 'list';
        }
    }
};
</script>



// WEBPACK FOOTER //
// src/app/components/aha-card-viewer.vue